import {useRef,useMemo} from "react";
import COMPONENT_MAP from '../Repository/Components.js';
import ErrorLogDetailPopup from './ErrorLogDetailPopup.js';

const ErrorLogsPopup=({userData,application,parent})=>{
    const list_name='error_logs_popup';
    const executeQuery=useRef(true);

    const renderPageList=useMemo(()=>{
        const Component=COMPONENT_MAP['PageList'];
        return Component?(
            <Component
                userData={userData}
                application={application}
                entityType={'ErrorLog'}
                height={window.innerHeight-370}
                entityParams={['_lang='+application.globalData.lang,'record_id='+parent.rowId,'table_name='+application.globalData.model_to_table_mapping[parent.entityType]]}
                file={'ErrorLogs.js'}
                list_name={list_name}
                filterComponent={null}
                focusOnSearchInput={false}
                title={application.getLocale("ErrorLogsTitle")}
                popupComponent={ErrorLogDetailPopup}
                navigateOnNew={null}
                checkboxSelection={true}
                disableRowSelectionOnClick={true}
                disableSelectionOnClick={true}
                executeQuery={executeQuery}
            />
        ):null; 
     },[userData,application,parent.entityType,parent.rowId]);

     return renderPageList;
}
export default ErrorLogsPopup;